import React from "react";
import { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { encStorage } from "../hooks/encStorage";
import { GET_LOYALTY } from "../services/Apis";
import axios from "axios";
import "bootstrap/dist/js/bootstrap.bundle.min";
import WhatsAppWidget from "./WhatsAppWidget";

function Header({ updateState }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [loyaltyCredit, setloyaltyCredit] = useState(0);
  const isActive = (path) => location.pathname.includes(path);
  const [sideBarVisibility, setsideBarVisibility] = useState(true);

  // Mock functions to replace PHP functions
  const getUnreadChat = (userId) => 5; // Replace with actual logic
  const fetchLoyalty = async () => {
    const token = encStorage.getItem("token");
    //console.log(token);
    try {
      const response = await axios.post(
        GET_LOYALTY,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setloyaltyCredit(response.data.loyalty ?? 0);
    } catch (error) {
      console.error("Error fetching loyalty:", error);
    }
  };
  useEffect(() => {
    fetchLoyalty(); // Run on page loaLoyalty, 60000); // Run every 60 seconds
    const interval = setInterval(fetchLoyalty, 60000);
    return () => clearInterval(interval);
  }, []);
  const nameInitials = (name) => {
    if (!name) return "";
    const nameParts = name.split(" ");
    if (nameParts.length > 1) {
      return nameParts[0][0] + nameParts[1][0];
    }
    return name.substring(0, 2);
  };
  const user = {
    id: encStorage.getItem("id"),
    name: encStorage.getItem("name"),
    client_code: encStorage.getItem("client_code"),
    id: encStorage.getItem("id"),
  };

  const handleLogout = () => {
    encStorage.removeItem("token");
    encStorage.removeItem("name");
    encStorage.removeItem("client_code");
    encStorage.removeItem("id");
    encStorage.removeItem("client_id");
    navigate("/login");
  };

  const handleSideBar = () => {
    setsideBarVisibility(sideBarVisibility === true ? false : true);
    updateState(sideBarVisibility);
    if (sideBarVisibility) {
      document.body.classList.add("sb-sidenav-toggled");
    } else {
      document.body.classList.remove("sb-sidenav-toggled");
    }
  };
  

  return (
    <>
      <nav className="sb-topnav navbar navbar-expand navbar-dark bg-secondary">
        {/* Navbar Brand */}
        <Link to="/" className="navbar-brand text-primary fs-1 text-start ps-2">
          <img src="/images/logo.png" alt="logo" className="w-50 w-sm-100" />
        </Link>
        <a
          className="btn btn-link btn-sm order-lg-0 me-1 me-lg-0"
          onClick={handleSideBar}
        >
          <i className="fas fa-bars"></i>
        </a>
        <Link className="btn btn-link btn-sm order-lg-0 me-1 me-lg-0" to="/">
          <i className="fas fa-home" aria-hidden="true"></i>
        </Link>

        <div className="dropdown d-flex ms-auto me-1 me-md-3 my-2 my-md-0">
          {loyaltyCredit >= 500 ? (
            <>
              <Link
                to="/redeem-credit"
                state={{ loyaltyCredit }}
                className="text-primary d-flex align-items-center fw-bold me-2 btn btn-primary btn-sm text-light"
              >
                <i className="fa-solid fa-crown me-1"></i>
                <span className="d-none d-md-block">Loyalty Credit</span>
                <span className="ms-1">{loyaltyCredit.toFixed(2) ?? 0}</span>
              </Link>
            </>
          ) : (
            <>
              <div className="text-primary d-flex align-items-center fw-bold me-2 btn btn-primary btn-sm text-light">
                <i className="fa-solid fa-crown me-1"></i>
                <span className="d-none d-md-block">Loyalty Credit</span>
                <span className="ms-1">{loyaltyCredit.toFixed(2) ?? 0}</span>
              </div>
            </>
          )}
        </div>
        <span
          className="text-dark text-end dropdown-toggle fs-custom d-flex align-items-center pe-2"
          type="button"
          id="menu1"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <span className="avatar">{nameInitials(user.name)}</span>
          {user.name}
        </span>
        <ul className="dropdown-menu" aria-labelledby="menu1">
          <li className="text-left ps-2">Account Id: {user.client_code}</li>
          <li className="d-flex align-items-center ps-2">
            <button
              className="btn-none text-dark text-decoration-none dropdown-item"
              onClick={handleLogout}
            >
              <i className="fa fa-power-off text-danger"></i> Logout
            </button>
          </li>
        </ul>
      </nav>
      <WhatsAppWidget />
    </>
  );
}

export default Header;
